/**
 * MESSAGE_TEMPLATES — Modelos de mensagens prontas para automações.
 *
 * Variáveis disponíveis (resolvidas em runtime pela Cloud Function):
 *   {memberName}       → Nome completo do membro (member.fullName)
 *   {firstName}         → Primeiro nome (member.fullName.split(" ")[0])
 *   {tenantName}        → Nome fantasia da academia (tenant.tradeName)
 *   {teacherName}       → Nome do professor (employee.fullName)
 *   {date}              → Data do evento formatada DD/MM/YYYY
 *   {trialDate}         → Data da aula experimental
 *   {trialTime}         → Horário da aula experimental
 *   {contractEndDate}   → Data fim do contrato (sale.endDate)
 *   {activityName}      → Nome da atividade/modalidade (evaluation.activityName)
 *   {levelName}         → Nível alcançado (evaluation.levelName)
 *   {results}           → Bloco de resultados formatado (gerado pelo EvaluationFormatter)
 *   {progressPercent}   → Percentual de evolução da avaliação
 */

const MESSAGE_TEMPLATES = {

    // ═══════════════════════════════════
    // ──  CAPTAÇÃO
    // ═══════════════════════════════════

    lead_registered: 
`Olá {firstName}, tudo bem? 😊

Que legal que você se interessou pela {tenantName}! 🏊‍♂️
Estamos prontos para te receber e mostrar como podemos te ajudar a alcançar seus objetivos.

Gostaria de agendar uma aula experimental gratuita? Responda esta mensagem e vamos encontrar o melhor horário para você!

Equipe {tenantName} 💪`,

    trial_scheduled:
`Olá {firstName}! 🎉

Sua aula experimental está confirmada!

📅 Data: {trialDate}
🕐 Horário: {trialTime}
📍 Local: {tenantName}
👨‍🏫 Professor(a): {teacherName}

*O que trazer:*
• Roupa de banho
• Toalha
• Disposição para se divertir! 😄

O(A) professor(a) {teacherName} já está preparando uma aula especial para você!
Estamos te esperando! Qualquer dúvida, é só chamar.
Equipe {tenantName}`,

    trial_scheduled_teacher:
`Olá {teacherName}! 📋

Uma nova aula experimental foi agendada para você!

👤 Aluno(a): {memberName} (Idade: {memberAge})
🏊 Modalidade: {activityName}
📅 Data: {trialDate}
🕐 Horário: {trialTime}

Vamos encantar mais um futuro aluno(a)! Mostre toda a energia e dedicação que fazem a {tenantName} ser especial. 🏊‍♂️💪

Boa aula!
Equipe {tenantName}`,

    trial_reminder:
`Oi {firstName}! 👋

Passando para lembrar da sua aula experimental aqui na {tenantName}!

📅 Data: {trialDate}
🕐 Horário: {trialTime}
👨‍🏫 Professor(a): {teacherName}

Não esqueça de trazer roupa de banho e toalha. O(A) professor(a) {teacherName} está ansioso(a) para te receber! 🏊‍♂️

Até lá! Equipe {tenantName}`,

    trial_reminder_teacher:
`Oi {teacherName}! 📝

Lembrando que você tem uma aula experimental agendada:

👤 Aluno(a): {memberName} (Idade: {memberAge})
🏊 Modalidade: {activityName}
📅 Data: {trialDate}
🕐 Horário: {trialTime}

Prepare-se para receber o(a) {firstName} com toda a dedicação. Cada aula experimental é uma oportunidade de inspirar! 🌟

Boa aula!
Equipe {tenantName}`,

    trial_day:
`Bom dia, {firstName}! ☀️

Hoje é o grande dia da sua aula experimental na {tenantName}! 🎉

🕐 Horário: {trialTime}
👨‍🏫 Professor(a): {teacherName}

O(A) professor(a) {teacherName} está preparando tudo com carinho para te receber. Lembre-se de trazer roupa de banho e toalha!

Te esperamos! 💪
Equipe {tenantName}`,

    trial_day_teacher:
`Bom dia, {teacherName}! ☀️

Hoje você tem uma aula experimental! 🎯

👤 Aluno(a): {memberName} (Idade: {memberAge})
🏊 Modalidade: {activityName}
🕐 Horário: {trialTime}

Vamos fazer essa aula ser inesquecível! Cada primeiro contato é a chance de mudar a vida de alguém. 🏊‍♂️✨

Boa aula e sucesso!
Equipe {tenantName}`,


    // ═══════════════════════════════════
    // ──  RETENÇÃO
    // ═══════════════════════════════════

    enrollment_welcome:
`Oi {firstName}! 👋

Como estão os primeiros dias aqui na {tenantName}? Esperamos que esteja curtindo! 🏊‍♂️

Estamos sempre à disposição para te ajudar no que precisar. Se tiver dúvidas sobre horários, atividades ou qualquer outra coisa, é só mandar uma mensagem!

Continue firme, os resultados vão aparecer! 💪
Equipe {tenantName}`,

    inactive_member:
`Oi {firstName}, tudo bem com você? 😊

Notamos que faz um tempinho que não te vemos por aqui na {tenantName}. Estamos com saudades! 🏊‍♂️

Sabemos que a rotina pode ser corrida, mas seus objetivos continuam te esperando. Que tal voltar esta semana?

Estamos na torcida por você! 💪
Equipe {tenantName}`,

    // ═══════════════════════════════════
    // ──  RELACIONAMENTO
    // ═══════════════════════════════════

    birthday:
`Feliz Aniversário, {firstName}! 🎂🎉

A família {tenantName} deseja um dia muito especial para você! 🥳

Obrigado por fazer parte da nossa equipe. Que venham muitos anos de saúde, conquistas e evolução!

Um grande abraço de toda a equipe! 🤗💪
{tenantName}`,

    // ═══════════════════════════════════
    // ──  RENOVAÇÃO
    // ═══════════════════════════════════

    contract_expiring:
`Oi {firstName}! 👋

Passando para avisar que o seu contrato na {tenantName} vence em breve, no dia {contractEndDate}. 📋

Para não perder o ritmo das suas atividades, entre em contato conosco para renovar!

Estamos à disposição para encontrar o melhor plano para você. 😊
Equipe {tenantName}`,

    contract_expired:
`Oi {firstName}! 📋

O seu contrato na {tenantName} venceu hoje ({contractEndDate}).

Não queremos que você pare a sua evolução! 🏊‍♂️

Entre em contato conosco para renovar e continuar aproveitando tudo que a {tenantName} tem para oferecer.

Estamos te esperando!
Equipe {tenantName}`,

    contract_renewal:
`Oi {firstName}! 🎉

Seu contrato na {tenantName} foi renovado com sucesso! ✅

Obrigado por continuar confiando em nós. Seguimos juntos na sua jornada de evolução! 🏊‍♂️💪

Equipe {tenantName}`,

    // ═══════════════════════════════════
    // ──  FINANCEIRO
    // ═══════════════════════════════════

    payment_overdue:
`Oi {firstName}, tudo bem? 😊

Identificamos que existe uma pendência financeira na sua conta aqui na {tenantName}.

Para manter seu acesso às aulas sem interrupção, pedimos que regularize o pagamento o mais breve possível. 📋

Se já realizou o pagamento, por favor desconsidere esta mensagem. Qualquer dúvida, estamos à disposição!

Equipe {tenantName}`,

};

export default MESSAGE_TEMPLATES;
